import { pxToRem } from '@geneo2-web/shared-ui';
import { Box } from '@mui/material';

interface AccuracyBarFillProps {
  valuePercent: number;
  height?: number;
  gradient?: string;
  color?: string;
}

export const ProgressBar = ({
  valuePercent,
  height = 8,
  color,
}: AccuracyBarFillProps) => {
  const gradient = 'linear-gradient(90deg, #667eea, #764ba2)';
  return (
    <Box
      sx={{
        width: '100%',
        height,
        backgroundColor: '#e2e8f0', // container bg (like your bar)
        borderRadius: pxToRem(height),
        // borderRadius: '20%',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          height: '100%',
          width: `${valuePercent}%`,
          borderRadius: pxToRem(height),
          background: color ? color : gradient,
          transition: 'width 0.8s ease-out',
        }}
      />
    </Box>
  );
};
